<template>
  <div class="main main--login main--background">
    <div class="container register">
      <img
        src="../../assets/img/geberit-logo-1.png"
        alt="geberit"
        class="register__logo"
      />

      <form class="form" @submit.prevent="submitAnswers">
        <div v-if="error" class="alert alert-danger" role="alert">
          {{ error }}
        </div>

        <input type="hidden" name="answers" v-model="formattedAnswers" />

        <div
          v-for="(question, index) in questions"
          :key="index"
          class="question-block"
        >
          <h3 class="question-block__title">
            {{ question.question }}
            <span class="required">*</span>
          </h3>

          <div class="question-block__answers">
            <div
              v-for="(answer, answerIndex) in question.answers"
              :key="answerIndex"
              class="answer-option"
              :class="{
                'answer-option--selected': isAnswerSelected(
                  question.identifier,
                  answer
                ),
                'answer-option--error':
                  showErrors && !hasAnswer(question.identifier),
              }"
              @click="
                selectAnswer(
                  question.identifier,
                  answer,
                  question.multipleChoice
                )
              "
            >
              {{ answer }}
            </div>
          </div>
          <div
            v-if="showErrors && !hasAnswer(question.identifier)"
            class="error-message"
          >
            To pole jest wymagane
          </div>
        </div>

        <div class="form__input-container">
          <button type="submit" class="button button--blue form__submit">
            Zakończ rejestrację
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import Vue from "vue";

export default {
  name: "RegisterQuestions",
  data() {
    return {
      error: "",
      showErrors: false,
      form: {
        assortment: [],
        experience: "",
        employees: "",
        tools: "",
        purchasePoint: [],
        programInfo: "",
      },
      questions: [
        {
          id: 1,
          identifier: "assortment",
          question: "Na jakim asortymencie pracujesz?",
          multipleChoice: true,
          answers: [
            "systemy rurowe",
            "stelaże podtynkowe i instalacje",
            "biały montaż",
            "wszystko po trochu",
            "inne",
          ],
        },
        {
          id: 2,
          identifier: "experience",
          question: "Jak długo pracujesz na asortymencie Geberit?",
          multipleChoice: false,
          answers: ["dopiero zaczynam", "2-10 lat", "ponad 10 lat"],
        },
        {
          id: 3,
          identifier: "employees",
          question: "Czy pracujesz sam, czy zatrudniasz pracowników (ilu)?",
          multipleChoice: false,
          answers: [
            "sam",
            "1-2 pracowników",
            "3-5 pracowników",
            "ponad 5 pracowników",
          ],
        },
        {
          id: 4,
          identifier: "tools",
          question: "Czy posiadasz na wyposażeniu narzędzia Geberit?",
          multipleChoice: false,
          answers: ["tak", "nie"],
        },
        {
          id: 5,
          identifier: "purchasePoint",
          question: "W jakim punkcie sprzedaży się zaopatrujesz?",
          multipleChoice: true,
          answers: [
            "lokalne hurtownie",
            "markety budowalne (DIY)",
            "salony łazienkowe",
            "sklepy internetowe",
          ],
        },
        {
          id: 6,
          identifier: "programInfo",
          question: "Skąd dowiedziałeś się o programie Geberit Pro?",
          multipleChoice: false,
          answers: [
            "od Doradcy Geberit",
            "od Handlowca w hurtowni",
            "z Serwisu Geberit (infolinia, chat)",
            "z internetu",
            "z polecenia innego Instalatora",
            "z Akademii Profesjonalisty Sopro",
          ],
        },
      ],
    };
  },
  methods: {
    hasAnswer(questionId) {
      return Array.isArray(this.form[questionId])
        ? this.form[questionId].length > 0
        : !!this.form[questionId];
    },
    validateForm() {
      return this.questions.every((question) =>
        this.hasAnswer(question.identifier)
      );
    },
    isAnswerSelected(questionId, answer) {
      if (Array.isArray(this.form[questionId])) {
        return this.form[questionId].includes(answer);
      }
      return this.form[questionId] === answer;
    },
    selectAnswer(questionId, answer, isMultiple) {
      if (isMultiple) {
        if (!Array.isArray(this.form[questionId])) {
          this.form[questionId] = [];
        }
        const index = this.form[questionId].indexOf(answer);
        if (index === -1) {
          this.form[questionId].push(answer);
        } else {
          this.form[questionId].splice(index, 1);
        }
      } else {
        this.form[questionId] = answer;
      }
    },
    formatAnswers() {
      return this.questions.map((question) => {
        const answers = Array.isArray(this.form[question.identifier])
          ? this.form[question.identifier]
          : [this.form[question.identifier]];

        return {
          question: question.question,
          id: question.id,
          answers,
        };
      });
    },
    submitAnswers() {
      this.showErrors = true;
      this.error = "";

      if (!this.validateForm()) {
        this.error = "Proszę odpowiedzieć na wszystkie pytania";
        return;
      }

      const formattedAnswers = this.formatAnswers();
      const vm = this;
      Vue.axios({
        method: "post",
        url: "/answers",
        data: formattedAnswers,
      }).then((response) => {
        console.log(response);
        vm.pending = false;
        //this.$toaster.success(response.data.message);
        this.$router.push("/");
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.required {
  color: red;
  margin-left: 5px;
}

.error-message {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

.answer-option {
  &--error {
    border: 1px solid red;
  }
}
</style>




// WEBPACK FOOTER //
// src/app/authentication/RegisterQuestions.vue